import Button from '@cloudscape-design/components/button';
import type { ResultColumn } from './ResultViewer';

/**
 * An "Actions" column with a Delete link per row.
 * Rows where `label` returns null (missing fields) get no link.
 */
export function deleteColumn<T>(label: (row: T) => string | null, onDelete: (row: T) => void): ResultColumn<T> {
  return {
    id: 'actions',
    // Left blank: the Delete link explains itself, and some pages have a data column called "Actions".
    header: '',
    value: () => '',
    sortable: false,
    cell: row => {
      const text = label(row);
      return text ? (
        <Button variant="inline-link" ariaLabel={`Delete ${text}`} onClick={() => onDelete(row)}>
          Delete
        </Button>
      ) : null;
    },
  };
}
